import React from 'react'

import * as Yup from 'yup'
import { Form, Select, Input } from 'formik-antd'
import { useCacheClient, getClientsForSelect } from '../../../../hooks/cache/client'
import { Divider } from 'antd'

export const ValidationSchema = Yup.object().shape({
  code: Yup.string().required('Project Code cannot be blank.'),
  name: Yup.string().required('Project Name cannot be blank.'),
  client: Yup.string().required('Client cannot be blank.'),
  first_name: Yup.string().required('First Name cannot be blank.'),
  last_name: Yup.string().required('Last Name cannot be blank.')
})

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0

const Formulario = ({ formik }) => {
  const { data: clientsData } = useCacheClient()
  const clients = getClientsForSelect(clientsData)

  return (
    <>
      <Divider orientation='left' plain>
        General Fields
      </Divider>
      <Form.Item label='Project Code' name='code' hasFeedback showValidateSuccess required>
        <Input name='code' placeholder='Project Code' />
      </Form.Item>

      <Form.Item label='Project Name' name='name' hasFeedback showValidateSuccess required>
        <Input name='name' placeholder='Project Name' />
      </Form.Item>

      <Form.Item label='Description' name='description'>
        <Input.TextArea name='description' placeholder='Description' />
      </Form.Item>

      <Form.Item label='Client' name='client' hasFeedback showValidateSuccess required>
        <Select
          placeholder='Client'
          name='client'
          showSearch
          options={clients}
          filterOption={_filter}
        />
      </Form.Item>

      <Divider orientation='left' plain>
        Primary Contact
      </Divider>
      <Form.Item
        label='First Name'
        name='first_name'
        hasFeedback
        showValidateSuccess
        required
      >
        <Input name='first_name' placeholder='First Name' />
      </Form.Item>
      <Form.Item
        label='Last Name'
        name='last_name'
        hasFeedback
        showValidateSuccess
        required
      >
        <Input name='last_name' placeholder='Last Name' />
      </Form.Item>
      <Form.Item label='Phone' name='phone'>
        <Input name='phone' placeholder='Phone' />
      </Form.Item>
      <Form.Item label='Email' name='email'>
        <Input name='email' placeholder='Email' />
      </Form.Item>
      <Form.Item label='Skype' name='skype'>
        <Input name='skype' placeholder='Skype' />
      </Form.Item>

      <Divider orientation='left' plain>
        Settings
      </Divider>

      <Form.Item label='Satisfaction Survery' name='satisfaction_survey' hasFeedback showValidateSuccess>
        <Select placeholder='Satisfaction Survery' name='satisfaction_survey'>
          <Select.Option>None</Select.Option>
          <Select.Option value='External'>External</Select.Option>
        </Select>
      </Form.Item>
      <Divider />

    </>
  )
}

export default Formulario
